<template>
    <section class="category" v-if="layout == 'default'">
        <WidgetOne/>
        <PostsBlock
        :posts="posts"
        :title="category.name"
        v-if="category"
        />
    </section>
    <BetanoMagLayout v-else-if="layout == 'betano-mag'" :category="category"/>
    <CasinoLayout v-else-if="layout == 'casino'" :category="category"/>
</template>

<script>
// @ is an alias to /sr
import BetanoMagLayout from '@/layouts/BetanoMag.vue'
import CasinoLayout from '@/layouts/CasinoLayout.vue'
import PostsBlock from '@/components/PostsBlock.vue'
import WidgetOne from '@/components/WidgetOne.vue'

export default {
    name: 'CategoryView',
    components: {
        BetanoMagLayout,
        CasinoLayout,
        PostsBlock,
        WidgetOne
    },
    props: {
        slugs: {
            type: String,
            required: true
        },
    },
    data() {
        return {
        }
    },
    methods: {
        fetchCategory() {
            this.$store.dispatch('categories/getOne', this.slug);
        },
        fetchPosts() {
            if( this.category ) {
                this.$store.dispatch('posts/getCategory', this.category);
            }
        },
    },
    computed: {
        category() {
            return this.$store.getters['categories/slug'](this.slug)
        },
        layout() {
            if( this.category ) {
                return this.category.layout
            }
            return 'default'
        },
        posts() {
            if( this.category == null ) {
                return []
            }
            return this.$store.getters['posts/category'](this.category)
        },
        slug() {
            return this.slugs[this.slugs.length - 1];
        }
    },
    watch: {
        slug: {
            immediate: true,
            handler() {
                console.log(this.slug)
                this.fetchCategory()
            },
        },
        category: {
            immediate: true,
            handler() {
                this.fetchPosts();
                this.$emit('ready');
                if( this.category == null ) {
                    return
                }
            }
        },
    },
    mounted() {
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/colors';

.category {
    padding-top: var(--menu-height);
}
</style>
